
import request from '../images/request_form.pdf';
import approvedPlants from '../images/Approved_Plants.pdf';
import modRequest from '../images/ARB_Modification_Request.pdf';
import rules from '../images/Rules_And_Regs.pdf';
import accomplishments2020 from '../images/LPGRA_2019-2020_Accomplishments.pdf';
import accomplishments2021 from '../images/LPGRA_2020-2021_Accomplishments.jpg';
import accomplishments2022 from '../images/2022_Accomplishments.jpg';
import accomplishments2023 from '../images/LPGRA_BOARD_ACCOMPLISHMENTS _2022-2023.pdf';
import accomplishments2024 from '../images/LPGRA_BOARD_ACCOMPLISHMENTS_2023-2024.pdf';
import servicesPg1 from '../images/Resident_services_page_1_2025.pdf';
import servicesPg2 from '../images/Resident_services_page_2_2025.pdf';
import newcomers from '../images/LPGRA_Flyer.pdf';

const LinksData = [
    {
        id: 21,
        path: newcomers,
        name: "Newcomers Meeting RA Information Letter"
    },
    {
        id: 22,
        path: servicesPg1,
        name: "Services Provided by Our Residents - Page 1"
    },
    {
        id: 23,
        path: servicesPg2,
        name: "Services Provided by Our Residents - Page 2"
    },
    {
        id: 20,
        path: rules,
        name: "Rules & Regulations"
    },
    {
        id: 1,
        path: "http://aamho.org/",
        name: "The Arizona Association of Manufactured Home and RV Owners (AAMHO)",
    },
    {
        id: 2,
        path: "http://thesman.com/",
        name: "Thesman Communities"
    },
    {
        id: 3,
        path: "http://treasurer.maricopa.gov/",
        name: "Maricopa County Tax Information"
    },
    {
        id: 4,
        path: "https://www.azgfd.com/",
        name: "Arizona Game & Fish"
    },
    {
        id: 5,
        path: "https://www.wunderground.com/?query=85209",
        name: "Local Weather"
    },
    {
        id: 7,
        path: "https://www.va.gov/",
        name: "U.S. Department of Veteran Affairs"
    },
    {
        id: 8,
        path: "https://www.mesaaz.gov/",
        name: "City of Mesa"
    },
    {
        id: 12,
        path: request,
        name: "Comment Form"
    },
    {
        id: 15,
        path: approvedPlants,
        name: "Plants Approved for Landscaping at Las Palmas Grand"
    },
    {
        id: 16,
        path: modRequest,
        name: "ARB Home Modification Form"
    },
    {
        id: 17,
        path: "https://www.testing.com/medicare-covered-preventative-screenings-resource/",
        name: "Medicare Covered Testing"
    },
    {
        id: '2019-2020',
        path: accomplishments2020,
        name: '2019-2020 Accomplishments'
    },
    {
        id: '2020-2021',
        path: accomplishments2021,
        name: '2020-2021 Accomplishments'
    },
    {
        id: '2021-2022',
        path: accomplishments2022,
        name: '2021-2022 Accomplishments'
    },
    {
        id: '2022-2023',
        path: accomplishments2023,
        name: '2022-2023 Accomplishments'
    },
    {
        id: '2023-2024',
        path: accomplishments2024,
        name: '2023-2024 Accomplishments'
    }
]

export default LinksData;